import {darken} from 'polished';

import {PaletteColorsEnum} from '../../../../core/src/models/api/paletteModel';
import {alphas, greys, greysDark, palette, paletteDark} from '../../styles/colorStyles';
import {colorPrimitive} from '../../styles/primitives/colorPrimitive';
import {darkAccentSemanticStyles, lightAccentSemanticStyles} from './accentSemanticStyles';
import {darkBackgroundSemanticStyles, lightBackgroundSemanticStyles} from './backgroundSemanticStyles';
import {lightBorderSemanticStyles, redesignedDarkBorderSemanticStyles} from './borderSemanticStyles';

export interface MessageSemanticStyles {
  background: string;
  border: string;
  borderRadius: number;
  containerBorder: string;
  header: string;
  commentText: string;
  readCommentBackground: string;

  commentReactionBackground: string;
  commentReactionHoverBackground: string;
  commentHighlightedBackground: string;
  highlightedBackground: string;
  highlightedHoverBackground: string;
  attachmentButton: string;
  attachmentButtonHover: string;
  attachmentBorder: string;

  shadow: string | undefined;
}

export const lightMessageSemanticStyles = {
  background: greys.white,
  border: greys.shade30,
  borderRadius: 16,
  containerBorder: alphas.black20,
  header: greys.shade90,
  commentText: greys.shade80,
  readCommentBackground: alphas.gray10,

  commentReactionBackground: palette[PaletteColorsEnum.BLUE].shade30,
  commentReactionHoverBackground: darken(0.05, palette[PaletteColorsEnum.BLUE].shade30),

  commentHighlightedBackground: palette[PaletteColorsEnum.BLUE].shade20,
  highlightedBackground: palette[PaletteColorsEnum.BLUE].shade20,
  highlightedHoverBackground: darken(0.05, palette[PaletteColorsEnum.BLUE].shade20),

  attachmentButton: greys.shade50,
  attachmentButtonHover: palette[PaletteColorsEnum.BLUE].shade40,
  attachmentBorder: alphas.black40,

  shadow: `0 1px 6px ${colorPrimitive.alpha.black.black200}, 0 4px 30px ${colorPrimitive.alpha.transparent}`,
} as const satisfies MessageSemanticStyles;

export const darkMessageSemanticStyles: MessageSemanticStyles = {
  background: greysDark.shade30,
  border: alphas.white20,
  borderRadius: 16,
  containerBorder: alphas.transparent,
  header: greysDark.shade90,
  commentText: greysDark.shade90,
  readCommentBackground: greysDark.shade20,

  commentReactionBackground: paletteDark[PaletteColorsEnum.BLUE].shade20,
  commentReactionHoverBackground: paletteDark[PaletteColorsEnum.BLUE].shade30,

  commentHighlightedBackground: paletteDark[PaletteColorsEnum.BLUE].shade20,
  highlightedBackground: paletteDark[PaletteColorsEnum.BLUE].shade20,
  highlightedHoverBackground: paletteDark[PaletteColorsEnum.BLUE].shade30,

  attachmentButton: greysDark.shade60,
  attachmentButtonHover: greysDark.shade70,
  attachmentBorder: greysDark.shade50,

  shadow: undefined,
} as const satisfies MessageSemanticStyles;

export const redesignedLightMessageSemanticStyles: MessageSemanticStyles = {
  ...lightMessageSemanticStyles,
  readCommentBackground: lightAccentSemanticStyles.grey.surface,
  background: lightBackgroundSemanticStyles.surface.highlight,

  border: lightBorderSemanticStyles.tertiary,
  containerBorder: lightBorderSemanticStyles.tertiary,
  borderRadius: 10,

  shadow: `0px 3px 12px 0px ${colorPrimitive.alpha.black.black100}`,
} as const satisfies MessageSemanticStyles;

export const redesignedDarkMessageSemanticStyles: MessageSemanticStyles = {
  ...darkMessageSemanticStyles,
  readCommentBackground: darkAccentSemanticStyles.grey.surface,
  background: darkBackgroundSemanticStyles.surface.highlight,

  border: redesignedDarkBorderSemanticStyles.tertiary,
  containerBorder: redesignedDarkBorderSemanticStyles.tertiary,
  borderRadius: 10,
} as const satisfies MessageSemanticStyles;
